import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import { VacinacaoGrupoConsolidadoFragment } from 'graphql/types.generated'
import { useMemo } from 'react'

import { grupoImunobiologicoLabel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { renderTextList } from './render-acompanhamentoCondicaoSaudeAccordion'
import { formatVacinasAplicadasConsolidado } from './utils-acompanhamentoCondicaoSaudeAccordion'

interface AcompanhamentoCondicaoSaudeVacinasConsolidadoSectionProps {
  vacinas?: ReadonlyArray<VacinacaoGrupoConsolidadoFragment>
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeVacinasConsolidadoSection({
  vacinas,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeVacinasConsolidadoSectionProps>) {
  const formattedVacinasByGrupo = useMemo(
    () =>
      (vacinas ?? []).map((grupo) => ({
        grupoImunobiologico: grupo.grupoImunobiologico,
        formattedVacinas: formatVacinasAplicadasConsolidado(grupo.vacinas),
      })),
    [vacinas]
  )

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='needleFilled' color={iconColor} />
          <Text fontWeight='bold'>Vacinas</Text>
        </HFlow>
      </Cell>
      {formattedVacinasByGrupo.map(({ grupoImunobiologico, formattedVacinas }) => (
        <Cell size={6} key={grupoImunobiologico}>
          <VFlow vSpacing={0.25}>
            <Text fontWeight='bold'>{grupoImunobiologicoLabel[grupoImunobiologico]}</Text>
            {renderTextList(formattedVacinas)}
          </VFlow>
        </Cell>
      ))}
    </Grid>
  )
}
